import { render, staticRenderFns } from "./SendToStock.vue?vue&type=template&id=b233ae22&scoped=true"
import script from "./SendToStock.vue?vue&type=script&lang=js"
export * from "./SendToStock.vue?vue&type=script&lang=js"
import style0 from "./SendToStock.vue?vue&type=style&index=0&id=b233ae22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b233ae22",
  null
  
)

export default component.exports